import { createHashRouter } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import Home from "../components/Home/Home";
import Register from "../components/Register/Register";
import Login from "../components/Login/Login";
import Categories from "../components/Categories/Categories";
import Brands from "../components/Brands/Brands";
import Products from "../components/Products/Products";
import Cart from "../components/Cart/Cart";
import NotFound from "../components/NotFound/NotFound";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";
import ProductDetails from "../components/ProductDetails/ProductDetails";
import Payment from "../components/Payment/Payment";
import AllOrders from "../components/AllOrders/AllOrders";
import ForgetPassword from "../components/ForgetPassword/ForgetPassword";
import VerifyResetCode from "../components/VerifyResetCode/VerifyResetCode";
import ForgotPasswordLayout from "../components/ForgotPasswordLayout/ForgotPasswordLayout";
import ResetPassword from "../components/ResetPassword/ResetPassword";

export const paths = {
  home: "/",
  register: "/register",
  login: "/login",
  categories: "/categories",
  brands: "/brands",
  products: "/products",
  cart: "/cart",
  productDetails: "/product_details",
  payment: "/payment",
  allOrders: "/allorders",
  forgetPassword: "/forget_password",
  verifyResetCode: "/forget_password/verify_reset_code",
  resetPassword: "/forget_password/reset_password",
  notFound: "*",
};

const routes = [
  {
    path: "",
    element: <Layout />,
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        ),
      },
      { path: paths.register, element: <Register /> },
      { path: paths.login, element: <Login /> },
      {
        path: paths.categories,
        element: (
          <ProtectedRoute>
            <Categories />
          </ProtectedRoute>
        ),
      },
      {
        path: paths.brands,
        element: (
          <ProtectedRoute>
            <Brands />
          </ProtectedRoute>
        ),
      },
      {
        path: paths.products,
        element: (
          <ProtectedRoute>
            <Products />
          </ProtectedRoute>
        ),
      },
      {
        path: paths.cart,
        element: (
          <ProtectedRoute>
            <Cart />
          </ProtectedRoute>
        ),
      },
      {
        path: `${paths.productDetails}/:productId`,
        element: (
          <ProtectedRoute>
            <ProductDetails />
          </ProtectedRoute>
        ),
      },
      {
        path: paths.payment,
        element: (
          <ProtectedRoute>
            <Payment />
          </ProtectedRoute>
        ),
      },
      {
        path: paths.allOrders,
        element: (
          <ProtectedRoute>
            <AllOrders />
          </ProtectedRoute>
        ),
      },
      {
        path: paths.forgetPassword,
        element: <ForgotPasswordLayout />,
        children: [
          { index: true, element: <ForgetPassword />, },
          { path: paths.verifyResetCode, element: <VerifyResetCode /> },
          { path: paths.resetPassword, element: <ResetPassword /> },
        ],
      },
      { path: paths.notFound, element: <NotFound /> },
    ],
  },
];
const router = createHashRouter(routes);

export default router;
